const constants = require('../constants');

const SELECTORS = {
    checkoutButton: '.js-checkout-btn',
    movComponent: '.js-shipping-discount-component',
    miniCartBody: '.cc-minicart__body'
};

const ATTRIBUTES = {
    mov: 'minimum-order-value-reached'
};

const PROPERTIES = {
    headerHeight: '--headerHeight'
};

/* Variabili globali */
window.isMobile = false;
window.isTablet = false;
window.isTabletPortrait = false;
window.isTabletLandscape = false;
window.isDesktop = false;

window.spsDataLayer = window.spsDataLayer || {};
window.spsDataLayer.logControl = window.spsDataLayer.logControl || {};

/* Funzioni Globali */
const setHeaderHeight = () => {
    if ($('.cc-header__main').length > 0) {
        const headerHeight = $(document).find('.cc-header__main').outerHeight(true);
        document.documentElement.style.setProperty('--headerHeight', headerHeight / 10 + 'rem');
    }
};

const setFooterHeight = () => {
    if ($('.cc-footer').length > 0) {
        const footerHeight = $(document).find('.cc-footer').outerHeight(true);
        document.documentElement.style.setProperty('--footerHeight', footerHeight / 10 + 'rem');
    }
};

const setFullHeight = () => {
    const windowHeight = $(window).innerHeight();
    document.documentElement.style.setProperty('--windowHeight', windowHeight / 10 + 'rem');
};

const responsiveResize = () => {
    getWindowSizes();
    setHeaderHeight();
    setFooterHeight();
    setFullHeight();
    getWindowBrowser();

    // Slider Init
    if ($('.js-slider').length > 0) {
        $('.js-slider').each(function () {
            $(this).not('.slick-initialized').slick();
        });
    }

    if ($('.js-slider-mini-cart').length > 0) {
        $('.js-slider-mini-cart').not('.slick-initialized').slick();
    }
};

const setPseudoHTMLFeedbackElement = () => {
    if ($('.invalid-feedback.cc-message').length > 0) {
        $('.invalid-feedback.cc-message').each(function () {
            if ($(this).next(".cc-double-rows-message").is('div')) {
            } else {
                $(this).html('&nbsp;');
            };
        });
    };
};

/**
 * Get the window size and set the global variables
 */
const getWindowSizes = () => {
    if (window.matchMedia('(max-width: 767.98px)').matches) {
        $('body')
            .addClass('cc-mobile')
            .removeClass('cc-tablet')
            .removeClass('cc-desktop');
        window.isMobile = true;
        window.isTablet = false;
        window.isMobileOrTablet = true;
        window.isDesktop = false;
    } else if (window.matchMedia('(max-width: 1023.98px)').matches) {
        $('body')
            .removeClass('cc-mobile')
            .addClass('cc-tablet')
            .removeClass('cc-desktop');
        window.isMobile = false;
        window.isTablet = true;
        window.isMobileOrTablet = true;
        window.isDesktop = false;
    } else {
        $('body')
            .removeClass('cc-mobile')
            .removeClass('cc-tablet')
            .addClass('cc-desktop');
        window.isMobile = false;
        window.isTablet = false;
        window.isMobileOrTablet = false;
        window.isDesktop = true;
    }
}

/**
 * Get the browser and add a class to the body
 */
getWindowBrowser = () => {
    const userAgent = navigator.userAgent;
    const isOpera = (!!window.opr && !!opr.addons) || !!window.opera || /OPR\//.test(userAgent);
    const isFirefox = typeof InstallTrigger !== 'undefined';
    const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
    const isIE = /*@cc_on!@*/false || !!document.documentMode;
    const isEdge = !isIE && !!window.StyleMedia;
    const isChrome = /Chrome/.test(userAgent) && !/Edge/.test(userAgent) && !/OPR/.test(userAgent) && navigator.vendor === 'Google Inc.';
    const isEdgeChromium = /Edg/.test(userAgent);
    const isBlink = /AppleWebKit\/537.36/.test(userAgent) && /Chrome\//.test(userAgent) && !/AppleWebKit\/537.36 \(KHTML, like Gecko\) Version\//.test(userAgent);

    if (isOpera) {
        $('body').addClass('cc-opera');
    } else if (isFirefox) {
        $('body').addClass('cc-firefox');
    } else if (isSafari) {
        $('body').addClass('cc-safari');
    } else if (isIE) {
        $('body').addClass('cc-ie');
    } else if (isEdge) {
        $('body').addClass('cc-edge');
    } else if (isEdgeChromium) {
        $('body').addClass('cc-edgeChromium');
    } else if (isChrome) {
        $('body').addClass('cc-chrome');
    } else if (isBlink) {
        $('body').addClass('cc-blink');
    } else {
        $('body').addClass('cc-unknown-browser');
    }
}

window.AOS = require('aos');

$(() => {
    responsiveResize();
    setPseudoHTMLFeedbackElement();
    $.fn.selectpicker.Constructor.BootstrapVersion = '4';

    // Select
    if ($('.js-form-select.selectpicker').length > 0) {
        if (window.isDesktop) {
            $('.js-form-select.selectpicker').each(function () {
                $(this).selectpicker('refresh');
                $(this).find('option[value=""]').hide().closest('select').selectpicker('refresh');
                const label = $(this).closest('.cc-form__wrap').find('.cc-form__label').html();
                const selectId = $(this).attr('id');
                const htmlString = '<label class="cc-form__label cc-visibility-hidden" for="button-' + selectId + '">' + label + '</label>';

                $(this).closest('.js-form-select').find('.dropdown-toggle').attr('aria-label', label);
                $(this).closest('.js-form-select').find('.dropdown-toggle').attr('aria-controls', 'button-' + selectId);
                $(this).closest('.js-form-select').find('.dropdown-menu > .inner').attr('id', 'button-' + selectId);
                $(this).closest('.js-form-select').find('.dropdown-menu').prepend(htmlString);
            });
        }
    }

    // Accessibility for slider
    if ($('.js-slider').not('.slick-initialized').length > 0) {
        $('.js-slider').not('.slick-initialized').each(function () {
            $(this).children().removeAttr('aria-hidden tabindex role aria-describedby');
        });
    }
    if ($('.js-slider.slick-initialized .js-tile-url').length > 0) {
        $('.js-slider.slick-initialized .js-tile-url').each(function () {
            $(this).attr('tabindex', '-1');
        });
    }

    // Prevent click on swipe
    $('.js-slider.slick-initialized').each(function () {
        let isSliding = false;
        $(this).on('beforeChange', function() {
            isSliding = true;
        });
        $(this).on('afterChange', function() {
            isSliding = false;
        });
        $(this).find('a').off('click').on('click', function(e) {
            if (isSliding) {
                e.stopImmediatePropagation();
                e.stopPropagation();
                e.preventDefault();
                return;
            }
        });
    });

    // Tooltip
    $('[data-toggle="tooltip"]').tooltip();

    // Data AOS
    AOS.init({
        // Global settings:
        disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
        startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
        initClassName: 'aos-init', // class applied after initialization
        animatedClassName: 'aos-animate', // class applied on animation
        useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
        disableMutationObserver: false, // disables automatic mutations' detections (advanced)
        debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
        throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)

        // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
        offset: 300, // offset (in px) from the original trigger point
        delay: 0, // values from 0 to 3000, with step 50ms
        duration: 1000, // values from 0 to 3000, with step 50ms
        easing: 'ease', // default easing for AOS animations
        once: true, // whether animation should happen only once - while scrolling down
        mirror: false, // whether elements should animate out while scrolling past them
        anchorPlacement: 'top-bottom' // defines which position of the element regarding to window should trigger the animation
    });
    // refresh AOS after images with a lazy loading are loaded
    $('img.cc-imgLazy').on('load', () => AOS.refresh());

    $(window).on('resize', () => {
        responsiveResize();
    });
});

/**
 * Display an alert message
 * @param {String} $text - Text to display
 * @param {String} $class - Class to add to the alert
 */
const alertMessage = ($text, $class) => {
    const successTimeout = 6000;
    const dangerTimeout = 8000;
    let timeout = successTimeout;

    if ($text && $text!="") {
        
        $('.js-alert-message').empty().html($text);

        $('.js-alert').addClass($class).removeClass('cc-active').addClass('cc-active');

        if ($('.js-alert').hasClass('cc-alert--danger')) {
            timeout = dangerTimeout;
        }
    
        const alertTimeout = setTimeout(() => {
            $('.js-alert').removeClass($class).removeClass('cc-active');
        }, timeout);

        // Trigger custom event for alert tracking
        $('.js-alert').trigger('show.bs.alert.custom');

        $('.js-close-alert').off('click').on('click', () => {
            clearTimeout(alertTimeout);
            $('.js-alert').removeClass($class).removeClass('cc-active');
        });
    }
};

/**
 * Attach a click handler to the page checkout button that conditionally prevents the checkout flow
 * when the minimum order value (MOV) requirement is not met.
 *
 * @returns {void} No return value. Side effects: registers an event handler and performs DOM animations.
 */
const shouldPreventCheckout = () => {

    $('body').on('click', SELECTORS.checkoutButton, (e) => {
        
        const $minimumOrderValue = $(SELECTORS.movComponent);
        const $miniCartBody = $(SELECTORS.miniCartBody);
        
        if ($minimumOrderValue.attr(ATTRIBUTES.mov) === "false") {
            e.preventDefault();

            if ($miniCartBody.length) {
                const targetScrollPosition = $minimumOrderValue.offset().top;
                $miniCartBody.animate({ scrollTop: 0 }, 300, () => {
                    shakeElement($minimumOrderValue);                
                });
            } else {
                const targetScrollPosition = $minimumOrderValue.offset().top;
                const headerHeight = document.documentElement.style.getPropertyValue(PROPERTIES.headerHeight).replace('rem', '') * 10;

                $('html, body').animate({scrollTop: targetScrollPosition - headerHeight - remToPx(1.6)}, 300, () => {
                    shakeElement($minimumOrderValue);
                });
            }
        }
    });
};

/**
 * Restart a CSS "shake" animation on the provided element.
 *
 * @param {jQuery} $el - jQuery-wrapped element whose shake animation should be triggered.
 * @returns {void}
 */
const shakeElement = ($el) => {
    $el.removeClass("cc-shake");
    void $el[0].offsetWidth;
    $el.addClass("cc-shake");
};

/**
 * Convert a rem value to pixels using the document's root (html) font size.
 *
 * @param {number} remValue - The rem value to convert (e.g., 1, 1.5).
 * @returns {number} The equivalent pixel value (e.g., 16 -> returns 16 when remValue is 1).
 */

const remToPx = (remValue) => {
  const htmlElement = document.documentElement;
  const computedStyle = window.getComputedStyle(htmlElement).fontSize;
  const rootFontSize = parseFloat(computedStyle);
  const pxValue = remValue * rootFontSize;
  return pxValue;
};

module.exports = {
    shouldPreventCheckout: shouldPreventCheckout,
    setHeaderHeight: setHeaderHeight,
    getWindowSizes: getWindowSizes,
    alertMessage: alertMessage,
    setPseudoHTMLFeedbackElement: setPseudoHTMLFeedbackElement
};